<template>
  <v-row class="mx-0 px-0 dense pb-0">

    <v-col cols="12"  class="pb-0 px-0">
      <v-card-title class="px-0 text--black">
        Featured Profile Details
      </v-card-title>
      <v-col class="px-0 py-0" cols="12" >
        <div class="text-body-2 font-weight-medium">
          Business Name
        </div>
      </v-col>
      <v-text-field outlined dense :rules="requiredRules" validate-on-blur class="pt-0"
                    :placeholder="`${currentSponsor.promoterType} name (Business name)`"
                    v-model="currentSponsor.name"></v-text-field>
      <v-col class="px-0 py-0" cols="12" md="12">
        <div class="text-body-2 font-weight-medium">
          {{currentSponsor.promoterType}} Type
        </div>
      </v-col>
      <v-text-field outlined dense :rules="requiredRules" validate-on-blur class="pt-0"
                    :placeholder="`${currentSponsor.promoterType} Type`"
                    v-model="currentSponsor.sponsorType"></v-text-field>
    </v-col>
    <v-col cols="12" class="px-0">
      <v-col class="px-0 py-0" cols="12" md="12">
        <div class="text-body-2 font-weight-medium">
          Bio
        </div>
      </v-col>
      <v-textarea outlined dense validate-on-blur :rules="requiredRules" :placeholder="`Bio`" class="pt-0"
                  single-line="false"

                    v-model="currentSponsor.bio"></v-textarea>
    </v-col>
    <v-col cols="12" class="mx-0 px-0">
      <v-col class="pt-0 px-0" cols="12" >
        <div class="text-body-2 font-weight-medium">
          Logo
        </div>
      </v-col>

      <v-col cols="12" class="pa-0 ma-0">
        <div
            class="sponsors-logo-dropzone-wrapper pa-0 ma-0"
            v-if="currentSponsor.logoURL == ''"
        >
          <div class="sponsors-logo-dropzone-wrapper d-flex align-center pa-0">

            <UploadImageDialog
                :show="showUploadLogoDialog"
                isDisplayImage
                previewType="rectangle"
                ref="uploadCoverImageDialog"
                @close="showUploadLogoDialog = false"
                @uploaded="handleSponsorLogoUploaded"
                :uploadToBusinessProfile="false"
                :generateCompressedImage="false"
            />
            <AddNewImage
                v-if="currentSponsor.logoURL == ''"
                :applyDashedBorder="true"
                :isRectangle="true"
                :width="300"
                :height="200"

                text="Upload Sponsor Logo"
                @click="showUploadLogoDialog = true"
                color="white"
                class="pa-0 align-center"
            >
              <div
                  class="d-flex align-center justify-center flex-column"
                  style="height: 100%"
              >
                <div>
                  <v-icon>mdi-image-outline</v-icon>
                </div>
                <div>Upload sponsor’s logo</div>
              </div>
            </AddNewImage>
          </div>
        </div>
        <div
            v-else
            class="sponsors-logo-dropzone-wrapper d-flex align-center"
        >
          <div class="d-flex">
            <v-card class="mr-2 pa-0 outlined-border">
              <v-img
                  :aspect-ratio="378 / 250"
                  :width="300"
                  :height="200"
                  :src="currentSponsor.logoURL"
              ></v-img>
            </v-card>
            <div class="d-flex flex-column">
              <AvatarButton
                  icon="mdi-pencil"
                  tooltipText="Edit logo"
                  className="d-inline-block mb-2"
                  @click="showUploadLogoDialog = true"
              />
              <AvatarButton
                  icon="mdi-trash-can"
                  tooltipText="Delete logo"
                  className="d-inline-block mb-2"
                  @click="currentSponsor.logoURL = ''"
              />
            </div>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>
<script>
import AvatarButton from "@/components/AvatarButton.vue";
import vueDropzone from "vue2-dropzone";
import Sponsor from "@/models/Sponsor";
import {mapGetters} from "vuex";
import UploadImageDialog from "@/components/UploadImageDialog.vue";
import AddNewImage from "@/components/AddNewImage.vue";

export default {
  computed: {
    ...mapGetters(["currentEvent", "userProfile", "currentSubEvent", "urlPrefixes"]),
  },
  components: {AddNewImage, UploadImageDialog, vueDropzone, AvatarButton},
  props: {
    currentSponsor: {
      type: Sponsor,
      required: true,
    }
  },
  methods: {
    async handleSponsorLogoUploaded(downloadURL) {
      this.currentSponsor.logoURL = downloadURL;
    }
  },
  data() {
    return {
      showUploadLogoDialog: false,

      requiredRules: [(v) => !!v || "This field is required"],
    }
  },
  created() {

  }

}
</script>

<style>
.sponsors-logo-dropzone-container {
  width: 80%;
  min-height: 180px;
  padding: 16px;
}

.sponsors-logo-dropzone-wrapper {
  background-color: #f6f7fc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 280px;

  /*margin-right: -4px; */
}

#sponsorsLogoDropzone {
  height: 200px;
  background-color: white !important;
  border: 3px dashed #5160774d !important;
  border-radius: 8px;
}
</style>